import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppContent } from "./AppContent";
import { useAuthStore } from '@stores/useAuthStore';
import { recordPlatformDailyVisitorOncePerUtcDay } from '@lib/apiClients';
import { PageErrorBoundary } from '@complex/PageErrorBoundary';
import { CelebrationProvider } from '@complex/CelebrationProvider';
import { ThemeProvider } from '@primitive/theme-provider';
import { DashboardMotionProvider } from '@primitive/motion';
import { CommunityInviteAcceptPage } from '@complex/CommunityInviteAcceptPage';

function AppRouterContent() {
  const location = useLocation();
  if (location.pathname.startsWith('/community-invite/')) {
    return <CommunityInviteAcceptPage />;
  }

  return <AppContent />;
}

export default function App() {
  useEffect(() => {
    const unsub = useAuthStore.getState().initialize();
    return () => unsub();
  }, []);

  useEffect(() => {
    void recordPlatformDailyVisitorOncePerUtcDay().catch((error) => {
      console.warn("Failed to record platform visitor metric", {
        error: error instanceof Error ? error.message : "unknown",
      });
    });
  }, []);

  return (
    <ThemeProvider>
      <div className="bbb-theme-frame">
        <PageErrorBoundary>
          <DashboardMotionProvider>
            <CelebrationProvider>
              <BrowserRouter>
                <AppRouterContent />
              </BrowserRouter>
            </CelebrationProvider>
          </DashboardMotionProvider>
        </PageErrorBoundary>
      </div>
    </ThemeProvider>
  );
}
